module.exports = __webpack_public_path__ + "img/stock5.cb5ee030.png";